var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"mk-button"},[_vm._v(" "+_vm._s(_vm.childItem.propsValue.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }